/**
 * Recorded-voice normalization inputs and the single provider target.
 *
 * Browser MediaRecorder output is an *internal* pipeline input. The worker
 * re-encodes it to AAC-LC in a seekable M4A (`audio/mp4`) before Meta send.
 *
 * MCP (WhatsApp Cloud API Media, Dec 2025): MP4 Audio `.m4a` / `audio/mp4`.
 * Instagram Messaging audio: acc, m4a, wav, mp4.
 * Messenger Saving Assets: audio/mp4 and audio/aac.
 */
export const NORMALIZED_RECORDED_VOICE_MIME = "audio/mp4";
export const NORMALIZED_RECORDED_VOICE_FILENAME = "voice-note.m4a";
/** Top-level MIME types the worker FFmpeg path can decode as recorder input. */
export const NORMALIZABLE_RECORDER_MIME_BASES = [
    "audio/mp4",
    "audio/webm",
    "audio/ogg",
    "audio/aac",
];
export function normalizeAudioMimeBase(mimeType) {
    return mimeType.toLowerCase().split(";")[0]?.trim() ?? "";
}
export function isNormalizableRecorderMime(mimeType) {
    const base = normalizeAudioMimeBase(mimeType);
    return NORMALIZABLE_RECORDER_MIME_BASES.includes(base);
}
/** True when the platform can send the normalized AAC/M4A voice object. */
export function platformAcceptsNormalizedRecordedVoice(allowedAudioMimeTypes) {
    return allowedAudioMimeTypes.some((allowed) => normalizeAudioMimeBase(allowed) === NORMALIZED_RECORDED_VOICE_MIME);
}
//# sourceMappingURL=recorded-voice-normalization.js.map